import React, { Component } from "react";
import PropTypes from "prop-types";
import Modal from "../Modal/Modal";

class SeriesConfirmationModal extends Component {
	constructor(props) {
		super(props);
		this.state = { updateAll: false };
	}

	onChange = updateAll => () => this.setState({ updateAll });

	onConfirm = () => {
		const { updateAll } = this.state;
		const { onConfirm, onClose } = this.props;
		onConfirm(updateAll);
		onClose();
	};

	onExited = () => this.setState({ updateAll: false });

	render() {
		const { lang } = global;
		const { show, actionType, onClose } = this.props;
		const { updateAll } = this.state;
		return (
			<Modal
				show={show}
				onHide={onClose}
				onExited={this.onExited}
			>
				<Modal.Header>
					<Modal.Title>{lang.t("Edit Job Series")}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Choose>
						<When condition={actionType === "update"}>
							{lang.t("You have updated the recurrence information_")}
							&nbsp;
							{lang.t(
								"Saving these changes may delete some jobs and override previous changes_",
							)}
							&nbsp;
							{lang.t("Do you want to save these changes_")}
						</When>
						<When condition={actionType === "delete" || actionType === "restore"}>
							{lang.t("This job is part of a recurring series_")}
							&nbsp;
							{lang.t(
								"dynamic.Do you want to act only this instance, or all upcoming instances of this series",
								{ action: actionType },
							)}
						</When>
						<When condition={actionType === "post"}>
							{lang.t("Apply the changes made to")}:
						</When>
						<Otherwise>
							{lang.t(
								"Saving these changes may overwrite some previous changes to jobs_",
							)}
						</Otherwise>
					</Choose>
					<div className="form-group">
						<div className="radio">
							<label htmlFor="individualJob">
								<input
									type="radio"
									id="individualJob"
									checked={!updateAll}
									onChange={this.onChange(false)}
								/>
								{lang.t("Only this job")}
							</label>
						</div>
						<div className="radio">
							<label htmlFor="allJobs">
								<input
									type="radio"
									id="allJobs"
									checked={updateAll}
									onChange={this.onChange(true)}
								/>
								{lang.t("All upcoming jobs in this series")}
							</label>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<button
						type="button"
						className="btn btn-link"
						onClick={onClose}
					>
						{lang.t("Cancel")}
					</button>
					<button
						type="button"
						className="btn btn-primary"
						onClick={this.onConfirm}
					>
						{lang.t("Confirm")}
					</button>
				</Modal.Footer>
			</Modal>
		);
	}
}

SeriesConfirmationModal.propTypes = {
	show: PropTypes.bool,
	actionType: PropTypes.string,
	onConfirm: PropTypes.func,
	onClose: PropTypes.func,
};

SeriesConfirmationModal.defaultProps = {
	show: false,
	actionType: null,
	onConfirm: () => {},
	onClose: () => {},
};

export default SeriesConfirmationModal;
